import { useEffect } from 'react';

import { useAuth } from '@/store/auth/auth.store';
import { useBetaFeaturesStore } from '@/store/beta-features/beta-features.store';

import type { FrontendFeature } from './frontend-features';

/**
 * Whether the person may see the feature: everyone may, unless it is marked beta and their
 * audience does not switch it on. False until that is known, so a beta feature never flashes.
 */
export const useFrontendFeature = (feature: FrontendFeature): boolean => {
  const personId = useAuth((s) => s.session?.id);
  const load = useBetaFeaturesStore((s) => s.load);
  const visible = useBetaFeaturesStore((s) => s.hidden !== null && !s.hidden.has(feature));

  useEffect(() => {
    if (personId) void load(personId);
  }, [personId, load]);

  return Boolean(personId) && visible;
};
